import ownerService from '@services/ownerService';
import onboardingV3Service from '@services/onboardingV3Service';
import store from '@store';
import onboardingService from '@services/onboardingService';

export default {
  data() {
    return {
      onboardingIds: [],
    };
  },
  methods: {
    init() {
      /* CALL THIS METHOD ON PAGE MOUNTED */
      if (this.$refs.onboardingButton) this.$refs.onboardingButton.load();
      onboardingService.getIds().then((data) => {
        this.onboardingIds = data.onboardingIds;
        store.state.userInformation.showDashboard = data.showDashboard;
        if (this.$refs.onboardingButton) this.$refs.onboardingButton.init();
      });
    },
    goToOnboarding() {
      if (this.hasPendingOnboarding)
        this.$router.push({name: 'onboardingDetails', params: {onboardingId: this.onboardingIds[0]}});
      else {
        let onboarding = {emailDisabled: false};
        onboarding.ownerId = store.state.userInformation.ownerId;
        onboardingV3Service
          .create(onboarding)
          .then((data) => {
            this.success(this.$t('onboarding.added'));
            this.$router.push({
              name: 'onboardingDetails',
              params: {onboardingId: data['Technical'].ID.value},
            });
          })
          .catch((e) => {
            this.addError(this.$t('error.' + e.response.data.error));
            this.$refs.onboardingButton.init();
          });
      }
    },
  },
  computed: {
    hasAccommodation() {
      return store.state.userInformation.showDashboard;
    },
    hasOnboarding() {
      return this.onboardingIds.length > 0;
    },
    hasPendingOnboarding() {
      return !this.hasAccommodation && this.hasOnboarding;
    },
  },
};
